import ReactGA from 'react-ga';
import {store} from 'main.js';

const trackingID = 'UA-137469056-1';

export const initGA = () => {
	ReactGA.initialize(trackingID);
};

export const PageView = () => {
	if (process.env.NODE_ENV !== "production") { return; }
	ReactGA.pageview(window.location.pathname + window.location.search);
};

/**
 * Event - Add custom tracking event.
 * @param {string} category
 * @param {string} action
 * @param {string} label
 * @param {string} user
 */
export const Event = (category, action, label, user=null) => {
	if (process.env.NODE_ENV !== "production") { return; }
	ReactGA.event({
		category: category,
		action: action,
		label: user === null ? store.getState().login.credentials.username + ": " + label : user + ": " + label 
	});
};


// WEBPACK FOOTER //
// ./src/GAnalytics.js